import React, { Fragment, useEffect, useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AppContext } from "@component/AppProvider";
import parse, { domToReact } from "html-react-parser";
import swal from "sweetalert";

import _API from "@util/api";
import _U from "@util/utilities";
import _DEF from "@config/defines";
import _CK from "@util/cookie";

export default (props) => {
    const { site } = useContext(AppContext);
    const navigate = useNavigate();

    if (_CK.isLogin()) {
        navigate("/");
        return "";
    }

    return (
        <Fragment>
            <div className="contents">
                {site?.naviJoin && parse(site?.naviJoin)}
                <div className="right">
                    <div className="contentsTop">
                        <h3>Create Account</h3>
                        <div className="location">
                            <a href="#" className="home">
                                home
                            </a>
                            <div className="loc_txt">
                                <span>Create Account</span>
                            </div>
                        </div>
                    </div>
                    <div className="contWrap">
                        <h4>Create Account</h4>
                        <Form />
                    </div>
                </div>
            </div>
        </Fragment>
    );
};

export const Form = (props) => {
    const { pageType } = props;
    const { site } = useContext(AppContext);

    const [cfg, setCfg] = useState([]);
    const [terms, setTerms] = useState(null);
    const [data, setData] = useState(null);
    const [idCheck, setIdCheck] = useState("N");

    const navigate = useNavigate();

    const loadConfig = () => {
        _API.get({ path: "/site/member/config" })
            .then((res) => {
                const { cfg, terms, infor } = res.data;
                setCfg(cfg);
                setTerms(terms);
                if (infor) {
                    setData(infor);
                }
            })
            .catch((e) => {
                _API.alert({ message: e.message });
            });
    };

    useEffect(() => {
        if (site?.siteCode) {
            loadConfig();
        }
    }, [site?.siteCode]);

    const onDataChange = (e) => {
        if (e.target.name === "id") {
            setIdCheck("N");
        }

        if (e.target.name === "nameFirst") {
            e.target.value = _U.capitalize(e.target.value);
        }
        if (e.target.name === "nameLast") {
            e.target.value = _U.allUppercase(e.target.value);
        }

        setData({ ...data, [e.target.name]: e.target.value });

        if (e.target.name == "country") {
            const phones = cfg.filter((c) => c.type === "PHONE");

            const tmps = {};
            for (let i in phones) {
                const p = phones[i];
                tmps[p.name] = _DEF.getDefinedLabel(_DEF.COUNTRY_PHONE, e.target.value) + (tmps[p.name] || "") + "-";
            }
            setData({ ...data, [e.target.name]: e.target.value, ...tmps });
        } else {
            if (e.target.type === "checkbox") {
                let tmp = data?.[e.target.name] ? JSON.parse(JSON.stringify(data?.[e.target.name])) : [];
                if (e.target.checked) {
                    tmp.push(e.target.value);
                } else {
                    tmp = tmp.filter((t) => t !== e.target.value);
                }
                setData({ ...data, [e.target.name]: tmp });
            } else {
                setData({ ...data, [e.target.name]: e.target.value });
            }
        }
    };

    const getElement = () => {
        const result = [];
        for (let i in cfg) {
            const c = cfg[i];
            if (data?.country !== "KR" && c.isKor === "Y") {
                continue;
            }
            result.push(
                <tr key={i}>
                    <th>
                        {c?.isMust === "Y" && <strong className="txt_red">*</strong>}
                        {c?.title}
                    </th>
                    <td colspan="3">{_U.getInputElementMake(c, data || "", onDataChange)}</td>
                </tr>
            );
        }

        return result;
    };

    const onSave = () => {
        if (!data?.id && pageType !== "MODIFY") {
            swal("Please enter your ID(Emaill address).");
            return;
        }
        if (idCheck !== "Y" && pageType !== "MODIFY") {
            swal("Please check your email format or check for duplicates.");
            return;
        }
        if (pageType === "MODIFY") {
            if (data?.passwd && data?.passwd?.length < 6) {
                swal("At least 6 characters long.");
                return;
            }
            if (data?.passwd && !data?.rePasswd) {
                swal("Please enter verify password.");
                return;
            }
            if (data?.passwd && data?.passwd !== data?.rePasswd) {
                swal("Please enter verify password.");
                return;
            }
        } else {
            if (!data?.passwd) {
                swal("Please enter your password.");
                return;
            }
            if (data?.passwd?.length < 6) {
                swal("At least 6 characters long.");
                return;
            }
            if (!data?.rePasswd) {
                swal("Please enter verify password.");
                return;
            }
            if (data?.passwd !== data?.rePasswd) {
                swal("Please enter verify password.");
                return;
            }
        }

        if (!data?.nameFirst) {
            swal("Please enter verify first name.");
            return;
        }
        if (!data?.nameLast) {
            swal("Please enter verify last name.");
            return;
        }
        if (!data?.country) {
            swal("Please choose your country.");
            return;
        }

        for (let i in cfg) {
            const c = cfg[i];
            if (c.isMust === "Y" && !data?.[c.name]) {
                if (data?.country !== "KR" && c.isKor === "Y") {
                    continue;
                }
                _U.getSwalElementMake(c);
                return;
            }
        }

        if (data?.agreement !== "Y") {
            swal("Please choose agreement.");
            return;
        }

        if (pageType === "MODIFY") {
            _API.post({ path: "/site/mypage/infor", data })
                .then((res) => {
                    navigate(`/mypage/infor`);
                })
                .catch((e) => {
                    _API.alert({ message: e.message });
                });
        } else {
            _API.post({ path: "/site/member", data })
                .then((res) => {
                    const { id } = res.data;
                    _CK.set("JOIN-ID", id);
                    navigate(`/join/final`);
                })
                .catch((e) => {
                    _API.alert({ message: e.message });
                });
        }
    };

    const onEmailCheck = (e) => {
        const email = e.target.value;

        if (!_U.isEmail(email)) {
            setIdCheck("E");
            setData({ ...data, id: "" });
        } else {
            _API.get({ path: "/site/member/id", data: { id: email } })
                .then((res) => {
                    const { isExsits } = res.data;

                    if (isExsits > 0) {
                        setIdCheck("U");
                        setData({ ...data, id: "" });
                    } else {
                        setIdCheck("Y");
                    }
                })
                .catch((e) => {
                    _API.alert({ message: e.message });
                });
        }
    };

    useEffect(() => {
        if (site?.lang === "KOR") {
            setData({ ...data, country: "KR" });
        }
    }, [site?.lang]);

    return (
        <div className="boxTable">
            <span className="  ">
                (<strong className="txt_red">*</strong> Indicates Required Field)
            </span>
            {/* {site?.lang==='KOR' && (

            )} */}
            <table className="tbl_signup ">
                <tr>
                    <th>
                        <strong className="txt_red">*</strong> ID (Email Address)
                    </th>
                    <td colspan="3">
                        {pageType === "MODIFY" ? (
                            data?.id
                        ) : (
                            <>
                                <input type="text" className="emailaddr" name="id" value={data?.id} onChange={onDataChange} onBlur={onEmailCheck} />
                                {idCheck === "E" && <span className="txt_point txt_red">Email address seems incorrect (check @ and .'s)</span>}
                                {idCheck === "U" && <span className="txt_point txt_red">This ID is used. Please type in a new ID</span>}
                                {idCheck === "Y" && <span className="txt_point txt_blue">Available to use</span>}
                                <p className="txt">
                                    Please make sure to enter a valid e-mail address as it will be your future contact point. <br />
                                    Also, keep in mind that once your ID is confirmed, you cannot modify it.
                                </p>
                            </>
                        )}
                    </td>
                </tr>
                <tr ng-if="!admin">
                    <th>
                        <strong className="txt_red">*</strong> Password
                    </th>
                    <td>
                        <input type="password" name="passwd" value={data?.passwd} onChange={onDataChange} />
                        {data?.passwd && data?.passwd.length < 6 && (
                            <>
                                <br />
                                <span className="txt_red font13">(Password is at least 6 characters long) </span>
                            </>
                        )}
                    </td>
                    <th>
                        <strong className="txt_red">*</strong> Verify Password
                        <br />
                        &nbsp;<span className="font13">(Re-enter your password)</span>
                    </th>
                    <td className="m_height1">
                        <input type="password" name="rePasswd" value={data?.rePasswd} onChange={onDataChange} />
                    </td>
                </tr>

                <tr>
                    <th>
                        <strong className="txt_red">*</strong> First Name
                    </th>
                    <td>
                        <input type="text" name="nameFirst" value={data?.nameFirst} onChange={onDataChange} />
                    </td>
                    <th>
                        <strong className="txt_red">*</strong> Last Name
                    </th>
                    <td>
                        <input type="text" name="nameLast" value={data?.nameLast} onChange={onDataChange} />
                    </td>
                </tr>
                {site?.lang !== "KOR" && (
                    <tr>
                        <th>
                            <strong className="txt_red">*</strong> Country
                        </th>
                        <td colspan="3">
                            <select name="country" value={data?.country} onChange={onDataChange}>
                                <option value="">COUNTRY CHOICE</option>
                                {_DEF.COUNTRY?.map((item, index) => (
                                    <option value={item.value} key={index}>
                                        {item.label}
                                    </option>
                                ))}
                            </select>
                        </td>
                    </tr>
                )}
                {getElement()}
            </table>
            {data?.country !== "KR" ? (
                <>
                    <h3 className="bullet_cicle">{terms?.privacyTitle}</h3>
                    <p className="termsBox">{terms?.privacy && parse(terms?.privacy)}</p>
                </>
            ) : (
                <>
                    <h3 className="bullet_cicle">{terms?.privacyTitleKor}</h3>
                    <p className="termsBox kr">{terms?.privacyKor && parse(terms?.privacyKor)}</p>
                </>
            )}
            <div className="agreeChk ta-c">
                <input type="radio" id="agree" name="agreement" value="Y" onClick={onDataChange} />
                <label for="agree">I agree</label>
                <input type="radio" id="notagree" name="agreement" value="N" onClick={onDataChange} />
                <label for="notagree">I do not agree</label>
            </div>
            <div className="btnArea1">
                <button type="button" className="btn1 btnBlue1" onClick={onSave}>
                    Submit
                </button>
            </div>
        </div>
    );
};

export const Final = () => {
    const [data, setData] = useState(null);
    const [id, setId] = useState("");
    const navigate = useNavigate();

    const loadContent = () => {
        _API.get({ path: "/site/content", data: { code1: "join", code2: "final" } })
            .then((res) => {
                if (res.data) {
                    setData(res.data);
                } else {
                    navigate("/");
                }
            })
            .catch((e) => {});
    };

    useEffect(() => {
        loadContent();
    }, []);

    useEffect(() => {
        if (_CK.get("JOIN-ID")) {
            setId(_CK.get("JOIN-ID"));
        }
    }, [_CK.get("JOIN-ID")]);

    if (data?.content && id) {
        return parse(data?.content, {
            replace(domNode) {
                if (domNode?.attribs?.id === "__ID__") {
                    return <>{id}</>;
                }
            },
        });
    }

    return <Fragment />;
};

export const Find = (props) => {
    const { site } = useContext(AppContext);
    const [id, setId] = useState("");
    const navigate = useNavigate();

    const onFind = () => {
        if (!id) {
            swal("Please enter your ID(E-mail)");
            return;
        }

        _API.post({ path: "/site/member/passwd", data: { id } })
            .then((res) => {
                swal(`Temporary password has been sent to ${id}.`);
                setId("");
            })
            .catch((e) => {
                _API.alert({ message: e.message });
            });
    };

    if (_CK.isLogin()) {
        navigate("/");
        return "";
    }

    return (
        <Fragment>
            <div className="contents">
                {site?.naviPasswd && parse(site?.naviPasswd)}
                <div className="right">
                    <div className="contentsTop">
                        <h3>Forgot Your Password?</h3>
                        <div className="location">
                            <a href="#" className="home">
                                home
                            </a>
                            <div className="loc_txt">
                                <span>Forgot Your Password?</span>
                            </div>
                        </div>
                    </div>
                    <div className="contWrap">
                        <div className="SuccessBox ta-c">
                            <div className="loginBox">
                                <p className="tit_findPassword">
                                    Forgot Your <span>password?</span>
                                </p>
                                <p>
                                    If you do not remember your password, please enter your ID(Email).
                                    <br />
                                    Temporary password will be sent out to your e-mail.
                                    <br />
                                    After you login with the temporary password, <br />
                                    you may change to a new password at personal information.
                                </p>
                                <div className="find_password">
                                    <form name="find_frm">
                                        <input type="text" name="id" placeholder="ID (E-mail)" onChange={(e) => setId(e.target.value)} />
                                        <button className="btn_blue1" type="button" onClick={onFind} style={{ verticalAlign: "unset" }}>
                                            Find Password
                                        </button>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
};
